var render = function (_h,_vm) {
var _obj;
var _c=_vm._c;return _c('div',{staticClass:"jz-chat-container",class:[
    _vm.data.class,
    _vm.data.staticClass,
    ( _obj = {
      fill: _vm.props.fill
    }, _obj["overflow-y-auto"] = _vm.props.overflowYAuto, _obj )
  ],style:([_vm.data.style, _vm.data.staticStyle])},[_c('div',{staticClass:"jz-chat-body"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }